var map = {
	"./alwayson.svg": 56,
	"./dashboard.svg": 57,
	"./distribution.svg": 58,
	"./draft.svg": 59,
	"./dragdrop.svg": 60,
	"./elevator.svg": 9,
	"./export.svg": 61,
	"./filter.svg": 62,
	"./integration.svg": 63,
	"./maturity.svg": 64,
	"./planning.svg": 65,
	"./rigcontrol.svg": 66,
	"./rigmove.svg": 67,
	"./roles.svg": 68,
	"./sso.svg": 69,
	"./workflow.svg": 70,
	"./zoom.svg": 71
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons ^\.\/.*$
// module id = 55
// module chunks = 0